import { Component, Input, ChangeDetectionStrategy } from '@angular/core';


@Component({
    selector: 'vw-skeleton-loader',
    imports: [],
    templateUrl: './skeleton-loader.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./skeleton-loader.component.scss']
})
export class SkeletonLoaderComponent {
  @Input() width: string = '100%';
  @Input() height: string = '100%';
  @Input() borderRadius: string = '0.25rem';
}
